/// <amd-module name="Artifacts/Root/components/SearchUpstreamsPanel" />

import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { encodeName } from "Artifacts/Root/helpers/PackageDecoderHelper";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { IProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import * as Res from "Artifacts/Root/Resources";
import { packageDetailsSearchUpstreams } from "Artifacts/Root/routing/Constants";
import * as React from "react";
import { generatePath, useHistory } from "react-router-dom";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { useComponentContext } from "VSS/Platform/Layout";
import { Panel } from "VSSUI/Panel";
import { RadioButton, RadioButtonGroup } from "VSSUI/RadioButton";
import { TextField } from "VSSUI/TextField";
import { getSafeId } from "VSSUI/Util";

export const SearchUpstreamsPanelId = "SearchUpstreamsPanel";

export interface ISearchUpstreamsPanelProps {
  onDismiss: () => void;
}

const SearchUpstreamsPanel: React.FC<ISearchUpstreamsPanelProps> = ({ onDismiss }) => {
  const { pageContext } = useComponentContext();
  const history = useHistory();
  const feed = useFeed();

  const protocols = Object.values(
    pageContext.getService<IProtocolService>("IProtocolService").getProtocolMapping(),
  );

  const [packageName, setPackageName] = React.useState<string>("");
  const [protocolId, setProtocolId] = React.useState<string>(protocols ? protocols[0].id : "");

  const textFieldDescriptionId = "search-upstreams-panel-description";

  const cargoEnabled = isFeatureFlagEnabled(pageContext, "Packaging.Feed.Cargo.EnableUI", false);

  return (
    <Panel
      className="search-upstreams-panel"
      titleProps={{ text: Res.SearchUpstreamsPanelTitle }}
      lightDismiss={false}
      onDismiss={onDismiss}
      footerButtonProps={[
        {
          onClick: onDismiss,
          text: Res.Modal_Cancel,
        },
        {
          primary: true,
          onClick: () => {
            history.push(
              generatePath(packageDetailsSearchUpstreams, {
                feedIdentifier: feed.feed?.name,
                protocol: protocolId,
                packageName: encodeName(packageName, protocolId),
              }),
            );
            onDismiss();
          },
          text: Res.SearchUpstreamsPanelPrimaryButton,
          disabled: !packageName,
        },
      ]}
    >
      <div>
        <RadioButtonGroup
          text={Res.SearchUpstreamsPanelRadioButtonsTitle}
          selectedButtonId={protocolId && protocolId}
          onSelect={(buttonId) => setProtocolId(buttonId)}
        >
          {protocols
            // List protocols that can have upstreams
            .filter((protocol) => {
              const upstreamingProps = protocol.getUpstreamingProperties(pageContext);
              return (
                protocol.isProtocolEnabled(pageContext) &&
                (upstreamingProps.isAadUpstreamsSupported ||
                  upstreamingProps.isCollectionUpstreamsSupported ||
                  upstreamingProps.isCustomPublicUpstreamsSupported ||
                  upstreamingProps.isPublicUpstreamsSupported)
              );
            })
            .map((protocol, i) => (
              <RadioButton id={protocol.id} key={i} text={protocol.name}></RadioButton>
            ))}
        </RadioButtonGroup>
        <TextField
          label={Res.SearchUpstreamsPanelTextFieldTitle}
          value={packageName}
          required
          onChange={(_event, value) => setPackageName(value)}
          ariaDescribedBy={getSafeId(textFieldDescriptionId)}
        />
        <p
          id={getSafeId(textFieldDescriptionId)}
          className="search-upstreams-panel-description-text"
        >
          {Res.SearchUpstreamsPanelTextFieldDescription}
        </p>
      </div>
    </Panel>
  );
};

registerModal(SearchUpstreamsPanelId, SearchUpstreamsPanel);
